import { CustomerListMatchingAttribute, CustomFieldType } from '~/types/api.graphql';

/** One inspected CSV column, as the agent passes it to the mapping form. */
export type CustomerListColumn = {
  index: number;
  columnName: string;
  suggestedAttribute?: CustomerListMatchingAttribute;
  /** The kept-column type the agent suggests from the column's name; `String` when absent. */
  suggestedFieldType?: CustomFieldType;
};

/** The API's matching-rule limits and which attributes identify a person on their own. */
export type CustomerListMatchingLimits = {
  maxRules: number;
  maxFieldsPerRule: number;
  identifierAttributes: CustomerListMatchingAttribute[];
};

/** One rule field as submitted: `[index, columnName, attribute]`, mapping one to one onto the API's rule field. */
export type CustomerListMatchingField = [number, string, CustomerListMatchingAttribute];

export const CUSTOMER_LIST_MAPPING_KIND = 'customerListMapping';
export const CUSTOMER_LIST_KEPT_COLUMNS_KIND = 'customerListKeptColumns';

/** The `VIQMatchingRules` value; `rules` map one to one onto `matchingRules`. */
export type CustomerListMappingValue = {
  kind: typeof CUSTOMER_LIST_MAPPING_KIND;
  attachmentId: string;
  rules: CustomerListMatchingField[][];
  /** Typed columns in no rule, unticked suggestions included, so a reopened form can group them without guessing. */
  unused: CustomerListMatchingField[];
  identifierAttributes: CustomerListMatchingAttribute[];
};

/** One kept column as submitted: `[index, columnName, savedName, type]`. */
export type CustomerListKeptField = [number, string, string, CustomFieldType];

/** The `VIQCustomFields` value; `fields` map one to one onto `customFields`. */
export type CustomerListKeptColumnsValue = {
  kind: typeof CUSTOMER_LIST_KEPT_COLUMNS_KIND;
  attachmentId: string;
  fields: CustomerListKeptField[];
};

/** A column's type, the same in every rule, by column index. */
export type CustomerListColumnTypes = Partial<Record<number, CustomerListMatchingAttribute>>;

/** A rule being edited: the indexes of its ticked columns. */
export type CustomerListRuleDraft = number[];

/** The mapping form's two views: one **Any of** section of ticked columns, or the rule editor. */
export type MatchingRulesView = 'simple' | 'custom';
